// extracted by mini-css-extract-plugin
export default {"summary":"styles_summary__GSZi8","title":"styles_title__dqZdU","subtitle":"styles_subtitle__dDZjN","stickyRoot":"styles_stickyRoot__DH6Ia"};